export enum TipoQuantidade {
  QUANTIDADE_META = 'QUANTIDADE_META',
  QUANTIDADE_REALIZADA = 'QUANTIDADE_REALIZADA'
}


